import { useEffect, useRef } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2, Printer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { usePrintReport } from "@/components/incidents/usePrintReport";
import { PrintableIncident } from "@/components/incidents/PrintableIncident";
import "@/styles/incident-print.css";

export default function IncidentPrint() {
  const {id} = useParams();
  const [params] = useSearchParams();
  const {report,images,failures,loading,error} = usePrintReport(id);
  const printed = useRef(false);
  useEffect(() => {
    document.body.classList.add("incident-print-page");
    const title = document.title;
    return () => { document.body.classList.remove("incident-print-page"); document.title = title; };
  }, []);
  useEffect(() => {
    if (report) document.title = `${report.meldungsart} – ${report.company_name || "Meldung"} – ${id}`;
  }, [report,id]);
  useEffect(() => {
    if (loading || error || failures.length || !report || params.get("autoprint") !== "1" || printed.current) return;
    let active = true;
    let frame;
    document.fonts.ready.then(() => {
      if (active) frame = requestAnimationFrame(() => { if (active) { printed.current = true; window.print(); } });
    });
    return () => { active = false; cancelAnimationFrame(frame); };
  }, [loading,error,failures,report,params]);
  return <div data-testid="incident-print-page" className="min-w-0 space-y-6">
    <div data-testid="print-toolbar" className="print-toolbar flex flex-wrap justify-between items-center gap-4">
      <Link data-testid="print-back" to={`/unfall/${id}`} className="flex gap-2 items-center text-sm text-zinc-400"><ArrowLeft size={16} />Zurück zur Meldung</Link>
      <Button data-testid="print-report-button" onClick={() => window.print()} disabled={loading || !!error || !report} className="bg-yellow-500 text-black hover:bg-yellow-400"><Printer size={16} />{failures.length ? "Ohne fehlende Bilder drucken" : "Drucken"}</Button>
    </div>
    {loading && <p data-testid="print-loading" role="status" className="print-toolbar text-zinc-400 flex gap-3"><Loader2 size={18} className="animate-spin" />Druckansicht wird vorbereitet…</p>}
    {error && <p data-testid="print-error" role="alert" className="print-toolbar text-red-300">{error}</p>}
    {failures.length>0 && <p data-testid="print-attachment-warning" role="alert" className="print-toolbar text-amber-300">{failures.length} Bild(er) konnten nicht geladen werden. Der automatische Druck wurde angehalten.</p>}
    {report && !loading && <PrintableIncident report={report} images={images} />}
  </div>;
}